import { useEffect } from 'react';
import Hero from './components/Hero';
import ResultsSummary from './components/ResultsSummary';
import CaseStudy from './components/CaseStudy';
import Strengths from './components/Strengths';
import Profile from './components/Profile';
import SNSCommunity from './components/SNSCommunity';
import PartnershipModels from './components/PartnershipModels';
import Flow from './components/Flow';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Compliance from './components/Compliance';
import { 
  generateWebSiteSchema, 
  generateOrganizationSchema, 
  generateServiceSchema 
} from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Add multiple Schema.org JSON-LD scripts
    const schemas = [
      generateWebSiteSchema(),
      generateOrganizationSchema(),
      generateServiceSchema()
    ];

    const scriptIds = ['schema-website', 'schema-organization', 'schema-service'];
    
    schemas.forEach((schema, index) => {
      const scriptId = scriptIds[index];
      let script = document.getElementById(scriptId) as HTMLScriptElement;
      
      if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      // Cleanup on unmount
      scriptIds.forEach(id => {
        const script = document.getElementById(id);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ResultsSummary />
      <CaseStudy />
      <Strengths />
      <Profile />
      <SNSCommunity />
      <PartnershipModels />
      <Flow />
      <Compliance />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
